export const analysisList = [
  {
    id: "analysis-1",
    type: "analysis",
    title: "《星轨彼端》第一季结局解析：星轨到底在回应什么",
    summary:
      "结局中那句“星轨回应的不是愿望，而是选择”究竟意味着什么？本文从三处伏笔出发，梳理第一季埋下的叙事线索。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20observatory%20interior%20with%20glowing%20star%20charts%20and%20floating%20constellation%20lines%2C%20mysterious%20deep%20blue%20and%20gold%20lighting%2C%20analytical%20illustration&width=800&height=500&seq=ana-01&orientation=landscape",
    category: "剧集解析",
    tags: ["星轨彼端", "结局", "伏笔", "科幻"],
    date: "2026-10-11",
    author: "解析组·沐星",
    popularity: 94,
    format: "",
    region: "",
    year: "",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "核心命题的提出",
        paragraphs: [
          "第一季结局抛出了一句耐人寻味的台词：“星轨回应的不是愿望，而是选择。”这句话其实是对全季主题的总结。",
          "弦月一路寻找的并非某个万能的答案，而是在无数次取舍中逐渐确认自己真正想要的东西。",
        ],
      },
      {
        id: "s2",
        heading: "三处关键伏笔",
        paragraphs: [
          "第一处是开篇祖父留下的观测笔记，其中反复出现“不要许愿”的提醒，暗示星轨并不奖励被动等待的人。",
          "第二处是中段岚对数据的怀疑，她始终拒绝浪漫化星轨，这为结局的理性收束埋下铺垫。",
          "第三处是旧日观测员的独白，他之所以走向极端，正因为他把选择权交给了星轨本身。",
        ],
      },
      {
        id: "s3",
        heading: "结局的留白",
        paragraphs: [
          "结局没有明确说明星轨的来源，这种克制反而让主题更清晰——重要的从来不是星轨是什么，而是人如何面对它。",
          "这也为第二季留下了足够的叙事空间：当选择带来代价时，主角是否仍能坚持自己的答案。",
        ],
      },
    ],
  },
  {
    id: "analysis-2",
    type: "analysis",
    title: "从《深海夜航》看密闭空间叙事的张力来源",
    summary:
      "为什么一部大部分场景发生在潜艇内部的作品能让人全程屏息？本文拆解密闭空间叙事的三个技术要点。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20submarine%20interior%20control%20room%20with%20flickering%20screens%20and%20tense%20crew%20silhouettes%2C%20moody%20teal%20and%20navy%20lighting%2C%20cinematic%20composition&width=800&height=500&seq=ana-02&orientation=landscape",
    category: "叙事研究",
    tags: ["深海夜航", "密室", "叙事", "悬疑"],
    date: "2026-10-07",
    author: "解析组·白露",
    popularity: 87,
    format: "",
    region: "",
    year: "",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "空间的限制即叙事的动力",
        paragraphs: [
          "密闭空间最大的优势在于：人物无法轻易逃离，任何矛盾都必须就地解决。",
          "《深海夜航》正是利用这一点，把角色之间的矛盾压缩到极致。",
        ],
      },
      {
        id: "s2",
        heading: "声音与黑暗的运用",
        paragraphs: [
          "影片大量使用环境音与静默的交替，营造出深海的压迫感。",
          "黑暗则被用来隐藏信息，观众与角色一样只能依靠声音判断方位，代入感因此大大增强。",
        ],
      },
      {
        id: "s3",
        heading: "信任作为破局关键",
        paragraphs: [
          "最终让船员们走出困境的并非外部的救援，而是彼此重新建立的信任。",
          "这也说明密闭空间叙事的终点往往不是逃离空间，而是修复关系。",
        ],
      },
    ],
  },
  {
    id: "analysis-3",
    type: "analysis",
    title: "《夜行侦探社》单元案件与主线的隐藏关联",
    summary:
      "看似独立的每一桩委托，其实都在悄悄指向主角的过去。本文整理前六话中容易被忽略的关联细节。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20noir%20detective%20desk%20covered%20with%20case%20files%2C%20photographs%20and%20red%20string%20connecting%20clues%2C%20deep%20blue%20and%20amber%20lighting%2C%20mystery%20illustration&width=800&height=500&seq=ana-03&orientation=landscape",
    category: "剧集解析",
    tags: ["夜行侦探社", "推理", "单元剧", "悬疑"],
    date: "2026-10-05",
    author: "解析组·沐星",
    popularity: 83,
    format: "",
    region: "",
    year: "",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "单元剧的表层结构",
        paragraphs: [
          "《夜行侦探社》表面上采用单元剧结构，每一话处理一桩独立委托。",
          "这种安排让作品节奏明快，但也容易让人忽略单元之间隐藏的线索。",
        ],
      },
      {
        id: "s2",
        heading: "反复出现的符号",
        paragraphs: [
          "前六话中多次出现同一款旧式怀表，它出现在不同的委托现场，却始终没有正面解释。",
          "此外，主角每次结案后都会在笔记本上写下一个日期，这些日期连起来恰好构成一条时间线。",
        ],
      },
      {
        id: "s3",
        heading: "主线与单元的互文",
        paragraphs: [
          "许多委托的动机都与“被遗忘”有关，这与主角自身的处境形成互文。",
          "可以说，单元案件是主线的镜子，照出主角不敢直视的过去。",
        ],
      },
    ],
  },
  {
    id: "analysis-4",
    type: "analysis",
    title: "《机甲纪元》里的战争伦理：机师是否自由",
    summary:
      "当战争由机甲代为进行，身处驾驶舱的机师究竟是战士，还是工具？本文从三方立场梳理作品的伦理追问。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20mecha%20cockpit%20interior%20with%20a%20pilot%20silhouette%20and%20holographic%20tactical%20display%2C%20blue%20and%20orange%20glow%2C%20dramatic%20sci-fi%20lighting&width=800&height=500&seq=ana-04&orientation=landscape",
    category: "主题探讨",
    tags: ["机甲纪元", "伦理", "战争", "科幻"],
    date: "2026-10-01",
    author: "解析组·白露",
    popularity: 80,
    format: "",
    region: "",
    year: "",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "三方立场的对撞",
        paragraphs: [
          "作品中至少存在三种对战争的看法：把机师视为消耗品的指挥部、相信战斗能带来和平的激进派，以及质疑战争本身的机师群体。",
          "三方立场在剧情中反复交锋，没有一方被简单定性为恶。",
        ],
      },
      {
        id: "s2",
        heading: "自由意志的困境",
        paragraphs: [
          "机师们看似在驾驶机甲做出决定，但他们的命令、训练乃至胜负标准都由他人设定。",
          "作品借此追问：在这样的结构中，个人的选择还剩多少意义？",
        ],
      },
      {
        id: "s3",
        heading: "人机关系的隐喻",
        paragraphs: [
          "机师与座机之间近乎伙伴的关系，某种程度上是对“被使用者”处境的隐喻。",
          "当机师开始为座机着想时，他们其实也在重新确认自己的人性。",
        ],
      },
    ],
  },
  {
    id: "analysis-5",
    type: "analysis",
    title: "《玻璃海之约》的色彩隐喻：为什么海水是透明的",
    summary:
      "全片反复强调“透明”，这并非单纯的画面风格，而是一套贯穿始终的情感语言。本文解读其中的色彩隐喻。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20summer%20seaside%20town%20with%20crystal%20clear%20water%20and%20vivid%20blue%20sky%2C%20nostalgic%20youth%20anime%20aesthetic%2C%20sunlight%20and%20sparkling%20reflections&width=800&height=500&seq=ana-05&orientation=landscape",
    category: "主题探讨",
    tags: ["玻璃海之约", "色彩", "青春", "隐喻"],
    date: "2026-09-27",
    author: "解析组·沐星",
    popularity: 76,
    format: "",
    region: "",
    year: "",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "透明的双重含义",
        paragraphs: [
          "片中的海水被处理得格外透明，既代表纯粹的青春心境，也暗示某种“转瞬即逝”。",
          "越是清澈透明的东西，越容易消失——这正是作品想传达的怅然。",
        ],
      },
      {
        id: "s2",
        heading: "色彩的温度变化",
        paragraphs: [
          "随着剧情推进，画面的色温从明亮的青蓝逐渐转向柔和的暖橙，对应主人公心境的变化。",
          "这种渐变的处理并不张扬，却让情绪有了可见的轨迹。",
        ],
      },
      {
        id: "s3",
        heading: "约定与告别",
        paragraphs: [
          "透明同时意味着“看得见却抓不住”，这与约定本身的脆弱形成呼应。",
          "正因如此，那句约定才显得既坚定又令人心疼。",
        ],
      },
    ],
  },
  {
    id: "analysis-6",
    type: "analysis",
    title: "《樱花武斗》的武打分镜为何如此耐读",
    summary:
      "好的武打分镜不只是画面的连续，而是节奏的设计。本文从攻防节奏与视线引导两个角度拆解本作的战斗呈现。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20dynamic%20sword%20duel%20between%20two%20fighters%20with%20motion%20lines%2C%20energetic%20action%20composition%2C%20pink%20petals%20and%20blue%20background%2C%20manga%20style&width=800&height=500&seq=ana-06&orientation=landscape",
    category: "创作技巧",
    tags: ["樱花武斗", "分镜", "动作", "漫画"],
    date: "2026-09-23",
    author: "解析组·白露",
    popularity: 72,
    format: "",
    region: "",
    year: "",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "攻防节奏的设计",
        paragraphs: [
          "本作的战斗很少一味加速，而是通过顿挫制造节奏：蓄势、爆发、留白，循环往复。",
          "正是这种张弛，让读者在高速阅读中仍有喘息的余地。",
        ],
      },
      {
        id: "s2",
        heading: "视线引导",
        paragraphs: [
          "作者善于利用对手的视线与身体的朝向，把读者的注意力自然引导到下一格的关键动作上。",
          "读者因此几乎不会在阅读中“迷路”，动作始终连贯。",
        ],
      },
      {
        id: "s3",
        heading: "失败的处理",
        paragraphs: [
          "值得注意的是，作品对失败的刻画同样用心，落败的一方往往有一个独立的分镜来承载情绪。",
          "这让胜负不再空洞，而是有重量、有代价的。",
        ],
      },
    ],
  },
  {
    id: "analysis-7",
    type: "analysis",
    title: "《光界旅人》的“选择”母题：光界规则解读",
    summary:
      "每一重光界都对应一种选择的困境。本文整理已公布的三重光界规则，并分析其与旅人内心的对应关系。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20surreal%20world%20of%20glowing%20light%20pathways%20and%20floating%20gates%2C%20warm%20amber%20and%20deep%20blue%20contrast%2C%20mystical%20fantasy%20illustration&width=800&height=500&seq=ana-07&orientation=landscape",
    category: "主题探讨",
    tags: ["光界旅人", "奇幻", "世界观", "原创"],
    date: "2026-09-19",
    author: "解析组·沐星",
    popularity: 70,
    format: "",
    region: "",
    year: "",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "光界即心境的具象",
        paragraphs: [
          "目前的设定显示，每一重光界都由一种“取舍规则”构成，旅人只有做出选择才能继续前行。",
          "换言之，光界并非地理空间，而是旅人内心困境的具象化。",
        ],
      },
      {
        id: "s2",
        heading: "三重规则的递进",
        paragraphs: [
          "第一重关于放手，第二重关于承担，第三重则关于原谅。三者的难度层层递进。",
          "这种设计让整段旅程呈现出清晰的心智成长曲线。",
        ],
      },
      {
        id: "s3",
        heading: "开放式结局的可能",
        paragraphs: [
          "作品暗示光界的尽头并没有所谓的“答案”，只有旅人自己的决定。",
          "这也与作品整体的诗意气质相吻合，留给观众充分的想象空间。",
        ],
      },
    ],
  },
  {
    id: "analysis-8",
    type: "analysis",
    title: "《银河列车》三十年后重看：留白式结局的意义",
    summary:
      "当年的结局让无数观众意难平，三十年后回看，那份留白是否有了新的意义？本文重新审视结尾的处理。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20retro%20space%20train%20disappearing%20into%20distant%20starfield%2C%20nostalgic%20cel%20animation%20aesthetic%2C%20deep%20blue%20cosmos%20with%20warm%20lights&width=800&height=500&seq=ana-08&orientation=landscape",
    category: "经典重读",
    tags: ["银河列车", "经典", "结局", "留白"],
    date: "2026-09-16",
    author: "解析组·白露",
    popularity: 68,
    format: "",
    region: "",
    year: "",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "当年的争议",
        paragraphs: [
          "《银河列车》的结局没有交代旅人的最终去向，这在当年引发了不少争议。",
          "部分观众认为这是叙事上的偷懒，也有人从中读出了深意。",
        ],
      },
      {
        id: "s2",
        heading: "留白的价值",
        paragraphs: [
          "三十年后回看，那份留白恰恰让作品具有了超越时代的开放性。",
          "每位观众都能把自身的经历投射进去，得到不同的答案。",
        ],
      },
      {
        id: "s3",
        heading: "对后世的启发",
        paragraphs: [
          "后来大量以旅途为主题的作品都借鉴了这种处理方式，用未完成来换取回味的空间。",
          "这或许就是经典之所以为经典的原因。",
        ],
      },
    ],
  },
  {
    id: "analysis-9",
    type: "analysis",
    title: "《魔法装订社》中的“记忆”与“传承”",
    summary:
      "修复一本书，其实是在修复一段记忆。本文从装订工艺的设定切入，谈作品反复书写的传承主题。",
    cover:
      "https://readdy.ai/api/search-image?query=anime%20old%20bookbinding%20workshop%20with%20glowing%20manuscripts%20and%20tools%2C%20warm%20amber%20light%20and%20deep%20blue%20shadows%2C%20cozy%20fantasy%20illustration&width=800&height=500&seq=ana-09&orientation=landscape",
    category: "主题探讨",
    tags: ["魔法装订社", "记忆", "传承", "奇幻"],
    date: "2026-09-13",
    author: "解析组·沐星",
    popularity: 66,
    format: "",
    region: "",
    year: "",
    rating: 0,
    sections: [
      {
        id: "s1",
        heading: "装订作为隐喻",
        paragraphs: [
          "在作品中，装订不只是工艺，更是一种“把散落的故事重新聚拢”的行为。",
          "这让修复书籍与修复记忆形成了直接的隐喻关系。",
        ],
      },
      {
        id: "s2",
        heading: "遗忘与保存",
        paragraphs: [
          "作品反复强调：被遗忘的故事并非毫无价值，它只是等待被重新拾起。",
          "装订社的存在，正是对遗忘的一种温柔抵抗。",
        ],
      },
      {
        id: "s3",
        heading: "传承的接力",
        paragraphs: [
          "从师父到学徒，作品的传承主题通过人物的日常互动自然展开，而非说教。",
          "当学徒第一次独立完成修复时，那条传承的线才算真正接上。",
        ],
      },
    ],
  },
];